import { IconButton, Modal, Text } from "@carbon6/c6-frontend-design";
import { useId, type ReactNode } from "react";
import { hatcheryTextModes } from "@/app/theme";
import { CopyButton } from "@/components/buttons";
import { HatModalHeader } from "@/components/modal";
import styles from "./ShareLinkRevealModal.module.css";

export type ShareLinkRevealModalProps = {
  // 표시할 링크 원문. null 이면 닫혀 있다.
  url: string | null;
  onClose: () => void;
};

// 발급은 성공했지만 클립보드에 넣지 못했을 때 링크를 직접 표시한다. 링크 원문은 발급 응답에만
// 있다. 그래서 토스트로 실패만 알리면 사용자는 링크를 잃고 기록만 남는다. 선택지가 없는 통보라
// 버튼은 닫기 하나다.
export function ShareLinkRevealModal({ url, onClose }: ShareLinkRevealModalProps): ReactNode {
  const titleId = useId();

  return (
    <Modal open={url !== null} onClose={onClose} size="md" aria-labelledby={titleId}>
      <HatModalHeader title="공유 링크" titleId={titleId} close />
      <div className={styles.body}>
        <Text variant={hatcheryTextModes["body-normal"]} className={styles.caption}>
          클립보드에 복사하지 못해 링크를 여기에 보여 드립니다. 이 창을 닫으면 링크를 다시 볼 수
          없으니 지금 복사해 주세요.
        </Text>
        <div className={styles.row}>
          <code className={styles.url}>{url}</code>
          <CopyButton text={url ?? ""} ariaLabel="공유 링크 복사" />
        </div>
        <div className={styles.actions}>
          <IconButton text="닫기" type="button" variant="solid" tone="primary" onClick={onClose} />
        </div>
      </div>
    </Modal>
  );
}
